import React from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import { goToPage, pageLoaded, reportAnalytics, getTechnicianVisitData, resetSelectedTimeSlots, getTechnicianTimeSlots, setSelectedVisit, cancelTechnicianTimeSlot, setIsShowCancelPopup, checkIsVisitTimeSlotCancelable, setIsShowErrorPopup, showMoreTimeSlots, reportDWH } from '../TechnicianUpdatesBlockSlice';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import VisitInfoList from '../Shared/VisitInfoList/VisitInfoList';
import CancelVisitPopUp from '../Shared/CancelVisitPopUp/CancelVisitPopUp';

const CustomerVisitInfoPage = (props) => {

  useExtendedEffect((runSideEffects) => {
    window.scrollTo(0, 0);
    getTechnicianVisitData();  
    if (runSideEffects()) {
    }
  }, []);

  async function getTechnicianVisitData() {
    props.showAppLoader();
    props.resetSelectedTimeSlots();
    var visits = await props.getTechnicianVisitData();
    props.hideAppLoader();
    if (visits?.payload?.Body?.length > 0) {
      props.pageLoaded();
      props.reportAnalytics({ eventCategory: 'technician_update', eventAction: "visibility_1", eventLabel: visits?.payload?.Body?.length });
    }
  }

  async function onClickUpdateVisitBtn(visit) {
    props.reportAnalytics({ eventCategory: 'technician_update', eventAction: "click_1", eventLabel: "element_2" });
    props.setSelectedVisit(visit);
    if (visit.isUpdatable) {
      props.showAppLoader();
      var request = {
        OrderId: visit.orderId,
        SelectedBezeqTimeSlot: null,
      }
      var timeSlots = await props.getTechnicianTimeSlots(request);
      props.hideAppLoader();
      if (timeSlots.payload != undefined && timeSlots.payload?.timeSlots?.length > 0) {
        props.showMoreTimeSlots();
        props.goToPage("technicianTimeSlotsPage");
      }
    }
    else {
      if (visit.isJointVisit) {
        props.reportDWH({ actionType: "Update Button Clicked", statusText: "Error", messageText: "Can't Update Cellcom Paired with Bezeq Technician", visit: visit });
      }
      props.setIsShowErrorPopup({ isShow: true, type: "TECHNICIAN_UPDATE_GENERAL_2_ERROR" })
    }
  }

  async function CheckIsVisitTimeCancelable(visit) {
    props.reportAnalytics({ eventCategory: 'technician_update', eventAction: "click_3", eventLabel: "element_11" });
    props.setSelectedVisit(visit);
    if (visit.isCancelable) {
      props.showAppLoader();
      await props.checkIsVisitTimeSlotCancelable(visit.orderId);
      props.hideAppLoader();
    }
    else {
      if (visit.isBezeq) {
        props.reportDWH({ actionType: "Cancel Technician Clicked", statusText: "Error", messageText: "Can't Cancel Bezeq Technician", visit: visit });
      }
      else if (visit.isJointVisit) {
        props.reportDWH({ actionType: "Cancel Technician Clicked", statusText: "Error", messageText: "Can't Cancel Cellcom Paired with Bezeq Technician", visit: visit });
      }
      else {
        props.reportDWH({ actionType: "Cancel Technician Clicked", statusText: "Error", messageText: "Can't Cancel Sale Technician", visit: visit });
      }
      props.setIsShowErrorPopup({ isShow: true, type: "TECHNICIAN_CANCEL_GENERAL_ERROR" });
    }

  }

  async function cancelVisitBtn() {
    props.reportAnalytics({ eventCategory: 'technician_update', eventAction: "click_4", eventLabel: "ביטול הגעת טכנאי" });
    props.showAppLoader();
    await props.cancelTechnicianTimeSlot(props.selectedVisit.orderId);
    props.hideAppLoader();
  }

  function closeCancelVisitPopUp() {
    props.reportAnalytics({ eventCategory: 'technician_update', eventAction: "click_4", eventLabel: "תשאירו את הטכנאי" });
    props.setIsShowCancelPopup(false);
  }

  return (
    <div className='visit-info-list-page'>
      {props.technicianVisits?.length > 0 && <VisitInfoList onClickUpdateVisitBtn={onClickUpdateVisitBtn} onClickCancelVisitBtn={CheckIsVisitTimeCancelable} />}
      <CancelVisitPopUp cancelVisitBtn={cancelVisitBtn} closeCancelVisitPopUp={closeCancelVisitPopUp} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    technicianVisits: state.technicianUpdatesBlock.technicianVisits,
    selectedVisit: state.technicianUpdatesBlock.selectedVisit,
    isShowCancelPopUp: state.technicianUpdatesBlock.isShowCancelPopUp,
    technicianTimeSlotPage: state.technicianUpdatesBlock.technicianTimeSlotPage
  };
};

const mapDispatchToProps = {
  goToPage,
  pageLoaded,
  reportAnalytics,
  showAppLoader,
  hideAppLoader,
  setSelectedVisit,
  getTechnicianVisitData,
  getTechnicianTimeSlots,
  setIsShowCancelPopup,
  checkIsVisitTimeSlotCancelable,
  cancelTechnicianTimeSlot,
  setIsShowErrorPopup,
  resetSelectedTimeSlots,
  showMoreTimeSlots,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerVisitInfoPage);
